import { render } from "./ExploreMaterials.vue?vue&type=template&id=0b6be7bc&scoped=true"
import script from "./ExploreMaterials.vue?vue&type=script&lang=js"
export * from "./ExploreMaterials.vue?vue&type=script&lang=js"

import "./ExploreMaterials.vue?vue&type=style&index=0&id=0b6be7bc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6be7bc"]])

export default __exports__